import { Directive, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[disableCopyPaste]',
  standalone: false,
})
export class DisableCopyPasteDirective {
  @Input('disableCopyPaste') disableCopyPaste: boolean = true;

  constructor() {}

  @HostListener('paste', ['$event']) blockPaste(e: ClipboardEvent) {
    if (!this.disableCopyPaste) return;
    e.preventDefault();
  }

  @HostListener('copy', ['$event']) blockCopy(e: ClipboardEvent) {
    if (!this.disableCopyPaste) return;
    e.preventDefault();
  }

  @HostListener('cut', ['$event']) blockCut(e: ClipboardEvent) {
    if (!this.disableCopyPaste) return;
    e.preventDefault();
  }
}
